
import { Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { bool_type, record_type, list_type, option_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Auto_generateBoxedDecoder_Z6670B51, fromString } from "../../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { int32ToString, createObj, uncurry2 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { isNullOrWhiteSpace, concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty as empty_1, append, singleton, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { singleton as singleton_1, mapIndexed, isEmpty, ofArray, empty, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { usePdfPageRendered } from "../../Widgets/PdfReady.js";
import { Variant } from "../../Variant.js";

export class ProcedureResultsPrintData extends Record {
    constructor(LogoUrl, TemplateName, TemplateDescription, StartDate, EndDate, State, PerformedBy, InformationFields, Booking, StateChange, Steps) {
        super();
        this.LogoUrl = LogoUrl;
        this.TemplateName = TemplateName;
        this.TemplateDescription = TemplateDescription;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.State = State;
        this.PerformedBy = PerformedBy;
        this.InformationFields = InformationFields;
        this.Booking = Booking;
        this.StateChange = StateChange;
        this.Steps = Steps;
    }
}

export function ProcedureResultsPrintData_$reflection() {
    return record_type("Procedure.Results.PrintView.ProcedureResultsPrintData", [], ProcedureResultsPrintData, () => [["LogoUrl", option_type(string_type)], ["TemplateName", string_type], ["TemplateDescription", string_type], ["StartDate", string_type], ["EndDate", option_type(string_type)], ["State", string_type], ["PerformedBy", option_type(string_type)], ["InformationFields", list_type(ProcedureResultsPrintInformationField_$reflection())], ["Booking", option_type(ProcedureResultsPrintBooking_$reflection())], ["StateChange", option_type(ProcedureResultsPrintStateChange_$reflection())], ["Steps", list_type(ProcedureResultsPrintStep_$reflection())]]);
}

export class ProcedureResultsPrintInformationField extends Record {
    constructor(Label, Value) {
        super();
        this.Label = Label;
        this.Value = Value;
    }
}

export function ProcedureResultsPrintInformationField_$reflection() {
    return record_type("Procedure.Results.PrintView.ProcedureResultsPrintInformationField", [], ProcedureResultsPrintInformationField, () => [["Label", string_type], ["Value", string_type]]);
}

export class ProcedureResultsPrintBooking extends Record {
    constructor(BookingType, Side, SenderName, ReceiverName, Quantity, Unit, SetItems, StorageName, BookingDate) {
        super();
        this.BookingType = BookingType;
        this.Side = Side;
        this.SenderName = SenderName;
        this.ReceiverName = ReceiverName;
        this.Quantity = Quantity;
        this.Unit = Unit;
        this.SetItems = SetItems;
        this.StorageName = StorageName;
        this.BookingDate = BookingDate;
    }
}

export function ProcedureResultsPrintBooking_$reflection() {
    return record_type("Procedure.Results.PrintView.ProcedureResultsPrintBooking", [], ProcedureResultsPrintBooking, () => [["BookingType", string_type], ["Side", string_type], ["SenderName", string_type], ["ReceiverName", string_type], ["Quantity", option_type(string_type)], ["Unit", option_type(string_type)], ["SetItems", list_type(string_type)], ["StorageName", option_type(string_type)], ["BookingDate", string_type]]);
}

export class ProcedureResultsPrintStateChange extends Record {
    constructor(IsBooked, OldStateKey, OldStateName, NewStateKey, NewStateName, ChangedAt, ChangedByName) {
        super();
        this.IsBooked = IsBooked;
        this.OldStateKey = OldStateKey;
        this.OldStateName = OldStateName;
        this.NewStateKey = NewStateKey;
        this.NewStateName = NewStateName;
        this.ChangedAt = ChangedAt;
        this.ChangedByName = ChangedByName;
    }
}

export function ProcedureResultsPrintStateChange_$reflection() {
    return record_type("Procedure.Results.PrintView.ProcedureResultsPrintStateChange", [], ProcedureResultsPrintStateChange, () => [["IsBooked", bool_type], ["OldStateKey", option_type(string_type)], ["OldStateName", string_type], ["NewStateKey", option_type(string_type)], ["NewStateName", string_type], ["ChangedAt", option_type(string_type)], ["ChangedByName", option_type(string_type)]]);
}

export class ProcedureResultsPrintStep extends Record {
    constructor(Name, IsCompleted, Elements) {
        super();
        this.Name = Name;
        this.IsCompleted = IsCompleted;
        this.Elements = Elements;
    }
}

export function ProcedureResultsPrintStep_$reflection() {
    return record_type("Procedure.Results.PrintView.ProcedureResultsPrintStep", [], ProcedureResultsPrintStep, () => [["Name", string_type], ["IsCompleted", bool_type], ["Elements", list_type(ProcedureResultsPrintElement_$reflection())]]);
}

export class ProcedureResultsPrintElement extends Record {
    constructor(Label, Type, Value, NoteKey, SignatureUrl, ImageUrls) {
        super();
        this.Label = Label;
        this.Type = Type;
        this.Value = Value;
        this.NoteKey = NoteKey;
        this.SignatureUrl = SignatureUrl;
        this.ImageUrls = ImageUrls;
    }
}

export function ProcedureResultsPrintElement_$reflection() {
    return record_type("Procedure.Results.PrintView.ProcedureResultsPrintElement", [], ProcedureResultsPrintElement, () => [["Label", string_type], ["Type", string_type], ["Value", option_type(string_type)], ["NoteKey", option_type(string_type)], ["SignatureUrl", option_type(string_type)], ["ImageUrls", option_type(list_type(string_type))]]);
}

function decodeData(encodedData) {
    try {
        const json = new TextDecoder('utf-8').decode(Uint8Array.from(atob(encodedData), c => c.charCodeAt(0)));
        const data = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(ProcedureResultsPrintData_$reflection(), undefined, undefined)), json);
        return (data.tag === 1) ? undefined : data.fields[0];
    }
    catch (matchValue) {
        return undefined;
    }
}

function StepElementPrint(props) {
    let elems_2, elems_1;
    const patternInput = useTranslation();
    if (props.Element.Type === "TextBlock") {
        return reactElement("div", {
            className: join(" ", ["py-2", "text-gray-600", "italic", "whitespace-pre-wrap", "break-words"]),
            "data-test-id": "procedure-results-print-element",
            children: props.Element.Label,
        });
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-6", "py-2"])], ["data-test-id", "procedure-results-print-element"], (elems_2 = [reactElement("div", {
            className: join(" ", ["w-1/3", "flex-shrink-0", "text-gray-600", "break-words"]),
            children: props.Element.Label,
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow", "min-w-0"])], (elems_1 = toList(delay(() => {
            let elems;
            const matchValue_1 = props.Element.Type;
            switch (matchValue_1) {
                case "Signature": {
                    const matchValue_2 = props.Element.SignatureUrl;
                    if (matchValue_2 == null) {
                        return singleton(reactElement("div", {
                            className: join(" ", ["border-b", "border-gray-400", "h-16", "w-2/3"]),
                        }));
                    }
                    else {
                        const url = matchValue_2;
                        return singleton(reactElement("img", {
                            className: join(" ", ["max-w-full", "max-h-48", "h-auto", "object-contain", "object-left"]),
                            "data-test-id": "procedure-results-print-signature",
                            src: url,
                        }));
                    }
                }
                case "PhotoCapture":
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-2"])], (elems = toList(delay(() => map((url_1) => reactElement("img", {
                        className: join(" ", ["max-h-48", "max-w-[45%]", "object-contain", "rounded", "border"]),
                        "data-test-id": "procedure-results-print-photo",
                        src: url_1,
                    }), defaultArg(props.Element.ImageUrls, empty())))), ["children", reactApi.Children.toArray(Array.from(elems))])]))));
                default:
                    return append(singleton(reactElement("div", {
                        className: join(" ", ["font-medium", "text-gray-900", "whitespace-pre-wrap", "break-words"]),
                        "data-test-id": "procedure-results-print-value",
                        children: defaultArg(props.Element.Value, "-"),
                    })), delay(() => {
                        const matchValue_3 = props.Element.NoteKey;
                        if (matchValue_3 == null) {
                            return empty_1();
                        }
                        else {
                            const key_25 = matchValue_3;
                            return singleton(reactElement("div", {
                                className: join(" ", ["text-sm", "text-gray-600"]),
                                "data-test-id": "procedure-results-print-note",
                                children: patternInput[0](key_25),
                            }));
                        }
                    }));
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
    }
}

function StepPrint(props) {
    let elems_3, elems_1, elems, elems_2;
    const t = useTranslation()[0];
    return reactElement("section", createObj(ofArray([["className", join(" ", ["mb-8", "break-inside-avoid"])], ["data-test-id", "procedure-results-print-step"], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "items-baseline", "gap-4", "pb-2", "mb-2", "border-b-2", "border-gray-800"])], (elems_1 = [reactElement("h3", createObj(ofArray([["className", join(" ", ["flex", "items-baseline", "gap-3", "text-lg", "font-bold", "text-gray-900"])], (elems = [reactElement("span", {
        className: join(" ", ["text-gray-500", "tabular-nums"]),
        "data-test-id": "procedure-results-print-step-number",
        children: int32ToString(props.Index + 1),
    }), reactElement("span", {
        children: props.Step.Name,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("span", {
        className: join(" ", toList(delay(() => append(singleton("text-sm"), delay(() => append(singleton("font-semibold"), delay(() => append(singleton("whitespace-nowrap"), delay(() => (props.Step.IsCompleted ? singleton("text-green-700") : singleton("text-gray-500"))))))))))),
        children: props.Step.IsCompleted ? t("procedure.completed") : t("procedure.not_completed"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["divide-y", "divide-gray-200"])], (elems_2 = toList(delay(() => (isEmpty(props.Step.Elements) ? singleton(reactElement("div", {
        className: join(" ", ["text-gray-400", "italic", "py-2"]),
        children: t("procedure.no_results"),
    })) : map((element) => createElement(StepElementPrint, {
        Element: element,
    }), props.Step.Elements)))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function HeaderFact(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], (elems = [reactElement("div", {
        className: join(" ", ["text-xs", "uppercase", "tracking-wide", "text-gray-500"]),
        children: props.Label,
    }), reactElement("div", {
        className: join(" ", ["font-medium", "text-gray-900"]),
        "data-test-id": concat(props.TestId, ..."-value"),
        children: props.Value,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function BookingPrint(props) {
    let quantity_1, quantity, unit, elems_3;
    const t = useTranslation()[0];
    const orDash = (value) => {
        if (value.trim() === "") {
            return "-";
        }
        else {
            return value;
        }
    };
    let quantity_2;
    const matchValue = props.Booking.Quantity;
    const matchValue_1 = props.Booking.Unit;
    quantity_2 = ((matchValue == null) ? undefined : ((matchValue_1 == null) ? ((quantity_1 = matchValue, quantity_1)) : ((quantity = matchValue, (unit = matchValue_1, concat(quantity, " ", ...t(unit)))))));
    return reactElement("section", createObj(ofArray([["className", join(" ", ["mb-8", "break-inside-avoid"])], ["data-test-id", "procedure-results-print-booking"], (elems_3 = toList(delay(() => append(singleton(reactElement("h2", {
        className: join(" ", ["text-lg", "font-bold", "text-gray-900", "pb-2", "mb-2", "border-b-2", "border-gray-800"]),
        children: t("procedure.booking.title"),
    })), delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "gap-x-6", "gap-y-3"])], (elems = toList(delay(() => append(singleton(createElement(HeaderFact, {
            Label: t("procedure.booking.booking_type"),
            TestId: "procedure-results-print-booking-type",
            Value: concat(t(props.Booking.BookingType), " (", t(props.Booking.Side), ...")"),
        })), delay(() => append(singleton(createElement(HeaderFact, {
            Label: t("procedure.booking.sender"),
            TestId: "procedure-results-print-booking-sender",
            Value: orDash(props.Booking.SenderName),
        })), delay(() => append(singleton(createElement(HeaderFact, {
            Label: t("procedure.booking.receiver"),
            TestId: "procedure-results-print-booking-receiver",
            Value: orDash(props.Booking.ReceiverName),
        })), delay(() => {
            let matchValue_3, quantity_3;
            return append((matchValue_3 = quantity_2, (matchValue_3 == null) ? (empty_1()) : ((quantity_3 = matchValue_3, singleton(createElement(HeaderFact, {
                Label: t("procedure.booking.quantity"),
                TestId: "procedure-results-print-booking-quantity",
                Value: quantity_3,
            }))))), delay(() => append(singleton(createElement(HeaderFact, {
                Label: t("procedure.booking.storage"),
                TestId: "procedure-results-print-booking-storage",
                Value: defaultArg(props.Booking.StorageName, "-"),
            })), delay(() => singleton(createElement(HeaderFact, {
                Label: t("procedure.booking.booking_date"),
                TestId: "procedure-results-print-booking-date",
                Value: props.Booking.BookingDate,
            }))))));
        })))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_2, elems_1;
            return !isEmpty(props.Booking.SetItems) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-3"])], ["data-test-id", "procedure-results-print-booking-set-items"], (elems_2 = [reactElement("div", {
                className: join(" ", ["text-xs", "uppercase", "tracking-wide", "text-gray-500"]),
                children: t("procedure.booking.set_items"),
            }), reactElement("ul", createObj(ofArray([["className", join(" ", ["list-disc", "list-inside", "font-medium", "text-gray-900"])], (elems_1 = toList(delay(() => map((item) => reactElement("li", {
                children: item,
            }), props.Booking.SetItems))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty_1();
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function StateChangePrint(props) {
    let elems_1;
    const t = useTranslation()[0];
    const stateName = (key, name) => {
        if (key == null) {
            return name;
        }
        else {
            return t(key);
        }
    };
    return reactElement("section", createObj(ofArray([["className", join(" ", ["mb-8", "break-inside-avoid"])], ["data-test-id", "procedure-results-print-state-change"], (elems_1 = toList(delay(() => append(singleton(reactElement("h2", {
        className: join(" ", ["text-lg", "font-bold", "text-gray-900", "pb-2", "mb-2", "border-b-2", "border-gray-800"]),
        children: t("procedure.state_change.title"),
    })), delay(() => {
        let elems;
        return props.StateChange.IsBooked ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "gap-x-6", "gap-y-3"])], (elems = [createElement(HeaderFact, {
            Label: t("procedure.state_change.old_state"),
            TestId: "procedure-results-print-state-change-old",
            Value: stateName(props.StateChange.OldStateKey, props.StateChange.OldStateName),
        }), createElement(HeaderFact, {
            Label: t("procedure.state_change.new_state"),
            TestId: "procedure-results-print-state-change-new",
            Value: stateName(props.StateChange.NewStateKey, props.StateChange.NewStateName),
        }), createElement(HeaderFact, {
            Label: t("procedure.state_change.changed_at"),
            TestId: "procedure-results-print-state-change-date",
            Value: defaultArg(props.StateChange.ChangedAt, "-"),
        }), createElement(HeaderFact, {
            Label: t("procedure.state_change.changed_by"),
            TestId: "procedure-results-print-state-change-user",
            Value: defaultArg(props.StateChange.ChangedByName, "-"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : singleton(reactElement("div", {
            className: join(" ", ["text-gray-500"]),
            "data-test-id": "procedure-results-print-state-change-not-booked",
            children: t("procedure.state_change.not_booked"),
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function ProcedureResultsPrintView(props) {
    let elems_5;
    const t = useTranslation()[0];
    usePdfPageRendered();
    const defaultLogoUrl = (Variant.tag === 1) ? "assets/images/inventory-one-logo.png" : "assets/images/mwk_logo.png";
    const matchValue = decodeData(props.Data);
    if (matchValue != null) {
        const data = matchValue;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["w-full", "p-8", "print:p-0", "bg-white", "text-gray-900"])], (elems_5 = toList(delay(() => {
            let elems;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "mb-6"])], (elems = toList(delay(() => append(singleton(reactElement("img", {
                className: join(" ", ["w-60", "mb-4"]),
                "data-test-id": "procedure-results-print-logo",
                src: defaultArg(data.LogoUrl, defaultLogoUrl),
            })), delay(() => append(singleton(reactElement("h1", {
                className: join(" ", ["text-2xl", "font-bold", "text-center"]),
                children: data.TemplateName,
            })), delay(() => (!isNullOrWhiteSpace(data.TemplateDescription) ? singleton(reactElement("p", {
                className: join(" ", ["text-gray-600", "text-center", "mt-2"]),
                children: data.TemplateDescription,
            })) : empty_1()))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                let elems_1;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-flow-col", "auto-cols-fr", "gap-6", "py-4", "mb-8", "border-t", "border-b", "border-gray-300"])], (elems_1 = toList(delay(() => append(singleton(createElement(HeaderFact, {
                    Label: t("procedure.start_date"),
                    TestId: "procedure-results-print-start-date",
                    Value: data.StartDate,
                })), delay(() => {
                    let matchValue_1, endDate;
                    return append((matchValue_1 = data.EndDate, (matchValue_1 == null) ? (empty_1()) : ((endDate = matchValue_1, singleton(createElement(HeaderFact, {
                        Label: t("procedure.end_date"),
                        TestId: "procedure-results-print-end-date",
                        Value: endDate,
                    }))))), delay(() => append(singleton(createElement(HeaderFact, {
                        Label: t("general.status"),
                        TestId: "procedure-results-print-state",
                        Value: data.State,
                    })), delay(() => {
                        const matchValue_2 = data.PerformedBy;
                        if (matchValue_2 == null) {
                            return empty_1();
                        }
                        else {
                            const performedBy = matchValue_2;
                            return singleton(createElement(HeaderFact, {
                                Label: t("procedure.performed_by"),
                                TestId: "procedure-results-print-performed-by",
                                Value: performedBy,
                            }));
                        }
                    }))));
                })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                    let elems_3, elems_2;
                    return append(!isEmpty(data.InformationFields) ? singleton(reactElement("section", createObj(ofArray([["className", join(" ", ["mb-8", "break-inside-avoid"])], ["data-test-id", "procedure-results-print-information-fields"], (elems_3 = [reactElement("h2", {
                        className: join(" ", ["text-lg", "font-bold", "text-gray-900", "pb-2", "mb-2", "border-b-2", "border-gray-800"]),
                        children: t("procedure.information_fields.title"),
                    }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "gap-x-6", "gap-y-3"])], (elems_2 = toList(delay(() => map((field) => createElement(HeaderFact, {
                        Label: t(field.Label),
                        TestId: "procedure-results-print-information-field",
                        Value: (field.Value !== "") ? field.Value : "-",
                    }), data.InformationFields))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : empty_1(), delay(() => {
                        let matchValue_3;
                        return append((matchValue_3 = data.Booking, (matchValue_3 == null) ? (empty_1()) : singleton(createElement(BookingPrint, {
                            Booking: matchValue_3,
                        }))), delay(() => {
                            let matchValue_4;
                            return append((matchValue_4 = data.StateChange, (matchValue_4 == null) ? (empty_1()) : singleton(createElement(StateChangePrint, {
                                StateChange: matchValue_4,
                            }))), delay(() => {
                                let elems_4;
                                return singleton(reactElement("div", createObj(singleton_1((elems_4 = toList(delay(() => mapIndexed((index, step) => createElement(StepPrint, {
                                    Index: index,
                                    Step: step,
                                }), data.Steps))), ["children", reactApi.Children.toArray(Array.from(elems_4))])))));
                            }));
                        }));
                    }));
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
    }
    else {
        return reactElement("div", {
            className: join(" ", ["p-8", "text-center", "text-red-600"]),
            children: t("general.a_error_occured"),
        });
    }
}

